<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <h3>{{ modalTitle }}</h3>
                <form @submit.prevent="submitForm">
                    <div class="form-group">
                        <label>{{ $t('name') }}</label>
                        <input v-model="form.name" type="text" class="form-control" required>
                    </div>
                    <div class="text-end mt-3">
                        <button class="btn btn-primary" type="submit">{{ $t('save') }}</button>
                        <button class="btn btn-secondary" @click="$emit('input', false)">Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Boolean,
        category: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            form: {
                name: ''
            }
        }
    },
    computed: {
        modalTitle() {
            return this.category ? 'Edit Category' : 'Add Category';
        }
    },
    watch: {
        category: {
            immediate: true,
            handler(newVal) {
                this.form.name = newVal ? newVal.name : '';
            }
        }
    },
    methods: {
        submitForm() {
            const url = this.category
                ? `/expense-categories/${this.category.id}`
                : '/expense-categories';

            const method = this.category ? 'put' : 'post';

            axios[method](url, this.form)
                .then(() => {
                    this.$emit('input', false); // close modal
                    this.$emit('saved'); // reload table
                });
        }
    }
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}
.modal-wrapper {
    width: 400px;
    background: #fff;
    padding: 20px;
    border-radius: 6px;
}
</style>
